import { render, staticRenderFns } from "./arrange-dialog.vue?vue&type=template&id=c1ddd36c&scoped=true"
import script from "./arrange-dialog.vue?vue&type=script&lang=js"
export * from "./arrange-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ddd36c",
  null
  
)

export default component.exports